const LikeType = {
  like: 'like',
  love: 'love',
  clap: 'clap',
  support: 'support',
  insightful: 'insightful',
  funny: 'funny',
};

const LikeTypeDetails = [
  {
    label: 'Like',
    icon: '/assets/icons/like.svg',
    type: LikeType.like,
    color: '#ECA400',
  },
  {
    label: 'Love',
    icon: '/assets/icons/heart.svg',
    type: LikeType.love,
    color: '#E85B48',
  },
  {
    label: 'Celebrate',
    icon: '/assets/icons/clap.svg',
    type: LikeType.clap,
    color: '#33CCCC',
  },
  {
    label: 'Support',
    icon: '/assets/icons/support.svg',
    type: LikeType.support,
    color: ' #E85B48',
  },
  {
    label: 'Insightful',
    icon: '/assets/icons/bulb.svg',
    type: LikeType.insightful,
    color: '#ECA400',
  },
  {
    label: 'Funny',
    icon: '/assets/icons/smile.svg',
    type: LikeType.funny,
    color: '#BC5090',
  },
];

const LikeIcons = {
  [LikeType.like]: '/assets/icons/like.svg',
  [LikeType.love]: '/assets/icons/heart.svg',
  [LikeType.clap]: '/assets/icons/clap.svg',
  [LikeType.support]: '/assets/icons/support.svg',
  [LikeType.insightful]: '/assets/icons/bulb.svg',
  [LikeType.funny]: '/assets/icons/smile.svg',
};

export { LikeTypeDetails, LikeIcons, LikeType };
